import classNames from 'classnames'
import { CampaignScheduleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React, { Component } from 'react'

import { Plural, t } from '@lingui/macro'

import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import BorderedBox, {
  BorderedBoxStats
} from '../../../../components/common/bordered-box/BorderedBox'
import { apolloClientPrivate } from '../../../../graphql/apolloClient'
import { CampaignStateEnum } from '../../../../graphql/private/PrivateSchemaTypes'
import { IconByCampaignType } from '../../utils'
import CampaignStatus from '../campaign-status/CampaignStatus'
import { DuplicateCampaignDocument } from './CampaignListItem.codegen'
import { Box, ButtonIcon, LinkBox } from 'front-end/src/components'
import IconDuplicate from 'front-end/src/components/common/icon/IconDuplicate'
import { brandColors } from 'shared/basicPalette'

import './CampaignListItem.less'

export default class CampaignListItem extends Component<{
  name: string
  scheduleType: CampaignScheduleEnum
  isActive: boolean
  campaignLink: string
  status: CampaignStateEnum
  audienceCount: number
  usersCompletedCount: number
  actionsCount: number
}> {
  async duplicateCampaign(campaignId) {
    const { data } = await apolloClientPrivate.mutate({
      mutation: DuplicateCampaignDocument,
      variables: {
        campaignId
      }
    })
    navigateTo(linkBuilder.campaign(data.admin.campaign.duplicate.id))
  }

  renderBorderedBoxStats() {
    if (this.props.scheduleType === CampaignScheduleEnum.IMMEDIATE) {
      return null
    }
    return (
      <BorderedBoxStats
        stats={[
          {
            className: 'active',
            caption: t`Active`,
            value: this.props.audienceCount
          },
          {
            className: 'completed',
            caption: t`Completed`,
            value: this.props.usersCompletedCount
          }
        ]}
      />
    )
  }

  render() {
    const { props } = this
    const className = classNames('CampaignListItem', {
      'is-inactive': !props.isActive
    })

    return (
      <LinkBox
        onClick={() => {
          navigateTo(this.props.campaignLink)
        }}
        className={className}
      >
        <BorderedBox>
          <div className="Campaign__desc">
            <div className="Campaign__icon">
              <IconByCampaignType scheduleType={props.scheduleType} />
            </div>
            <div className="Campaign__desc__title">{props.name}</div>
            <Box ml="8px">
              <CampaignStatus status={props.status} />
            </Box>
          </div>
          <div className="Campaign__actions-count">
            <Plural
              value={props.actionsCount}
              one="# action"
              other="# actions"
            />
          </div>
          {this.renderBorderedBoxStats()}
          <ButtonIcon
            circular
            hint={t`Create a copy`}
            aria-label={t`Create a copy`}
            className="ActionButton"
            onClick={(ev: React.MouseEvent<HTMLSpanElement>) => {
              this.duplicateCampaign(this.props.campaignLink.split('/').pop())
              ev.preventDefault()
              ev.stopPropagation()
              return false
            }}
            icon={
              <IconDuplicate color={brandColors.grey[500]} boxSize="16px" />
            }
          />
        </BorderedBox>
      </LinkBox>
    )
  }
}
